import api from "./axiosConfig";

export const getOurProjects = async () => {
  const res = await api.get("Project/ourprojects/");
  return res.data[0]; // backend returns an array with one main object
};
